import React from 'react';
import PropTypes from 'prop-types';
import { UnmountClosed } from 'react-collapse';
import { presets } from 'react-motion';

import Arrow from './shared/Arrow';
import Body from './shared/Body';
import Header from './shared/Header';
import TextInput from './shared/TextInput';
import Title from './shared/Title';
import Wrapper from './shared/Wrapper';

class LawFirmFilter extends React.Component {
  constructor() {
    super();

    this.state = {
      isOpened: true,
    };

    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse() {
    this.setState(prevState => ({
      isOpened: !prevState.isOpened,
    }));
  }

  render() {
    const {
      filterValue,
      filterUpdate,
    } = this.props;
    const { isOpened } = this.state;

    return (
      <Wrapper>
        <Header
          onClick={this.toggleCollapse}
          $isOpened={isOpened}
          id="filterLawFirmCollapseToggle"
        >
          <Title>Law Firm</Title>
          <Arrow isOpened={isOpened} />
        </Header>
        <UnmountClosed
          presets={presets.gentle}
          isOpened={isOpened}
        >
          <Body
            id="filterLawFirmWrapper"
          >
            <TextInput
              $filterValue={filterValue}
              $filterUpdate={filterUpdate}
              placeholder="Law Firm"
              $filterField="lawFirm"
              inputId="filterLawFirmInput"
              submitId="filterLawFirmSubmit"
            />
          </Body>
        </UnmountClosed>
      </Wrapper>
    );
  }
}

LawFirmFilter.propTypes = {
  filterUpdate: PropTypes.func.isRequired,
  filterValue: PropTypes.string,
};

LawFirmFilter.defaultProps = {
  filterValue: '',
};

LawFirmFilter.displayName = 'LawFirmFilter';

export default LawFirmFilter;
